import { createSelector } from '@ngrx/store';
import * as fromFeature from '@app/shared/store/reducers';
import * as fromConverter from '@app/shared/store/reducers/converter.reducers';
export const selectConverterState = createSelector(
  fromFeature.selectSharedFeatureState,
  (state: fromFeature.State) => state.converter
);

export const getIsProjectLoaded = createSelector(selectConverterState, fromConverter.getIsProjectLoaded);
